import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Clock, Facebook, Instagram, MailIcon, PhoneCallIcon } from "lucide-react";
import React from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const ContactoSection = () => {
  return (
    <section
      className="w-full py-12 md:py-24 lg:py-32 text-white"
      id="contacto"
    >
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <h2 className="text-2xl text-center font-bold tracking-tighter sm:text-3xl lg:text-4xl text-white mb-10">
          Contáctanos
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-32 xl:gap-96">
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <PhoneCallIcon className="w-6 h-6 text-white" />
              <div>
                <h3 className="font-semibold">Teléfonos</h3>
                <p className="text-white/50">
                  Jorge Echegaray: +54 3525 44-7655
                </p>
                <p className="text-white/50">
                  Tristán Echegaray: +54 351 732-2764
                </p>
                <p className="text-white/50">
                  Guadalupe Sueldo: +54 3525 47-9014
                </p>
                <p className="text-white/50">
                  Administración: +54 3525 45-4436
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <MailIcon className="w-6 h-6 text-white" />
              <div>
                <h3 className="font-semibold">Email</h3>
                <p className="text-white/50">adm.logisticahuemul@gmail.com</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <Clock className="w-6 h-6 text-white" />
              <div>
                <h3 className="font-semibold">Horario de Atención</h3>
                <p className="text-white/50">
                  Lunes a Viernes, 8:00 AM - 5:00 PM
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <Instagram className="w-6 h-6 text-white" />
              <div>
                <h3 className="font-semibold">Instagram</h3>
                <a
                  href="https://www.instagram.com/logisticahuemul/?hl=es"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  @logisticahuemul
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <Facebook className="w-6 h-6 text-white" />
              <div>
                <h3 className="font-semibold">Facebook</h3>
                <a
                  href="https://www.facebook.com/logisticahuemulsrl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  Logistica Huemul Facebook
                </a>
              </div>
            </div>
            <div className="mt-6 flex items-center space-x-4">
              <FontAwesomeIcon
                className="w-6 h-6 text-white"
                icon={faWhatsapp}
              />
              <div>
                <h3 className="font-semibold mb-2">WhatsApp</h3>
                <a
                  href="https://wa.me/543525454436"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex h-10 items-center justify-center rounded-xl bg-green-500 px-8 text-sm font-medium text-white shadow transition-colors hover:bg-green-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
                >
                  Contactar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactoSection;